<template>
  <div>
    <div class="header">
      <header-tag :title="'手机短信验证'"></header-tag>
    </div>
    <div class="form-body">
      <div
        class="form-top"
        style="line-height:24px;"
      >该操作将会<b
          class="f14 fw "
          style="color:rgb(0, 102, 204)"
          v-if="state == true"
        >关闭</b><b
          v-else
          class="f14 fw "
          style="color:rgb(0, 102, 204)"
        >开启</b><b class="f14 fw">远程管理端</b>登录时的短信验证功能，为了您的账号安全，建议后续使用微信或APP扫码登录。同时设置复杂的账号密码，以确保账号安全。</div>
      <div class="form-left">
        <p>短信验证码:</p>
        <p></p>
      </div>
      <div
        class="form-right"
        style="margin-top:8px;"
      >
        <p class="clearfix">
          <input
            type="text"
            placeholder="请输入验证码"
            v-model="smsCode"
            class="fl"
            style="width:70%;"
          />
          <b
            class="fl cp"
            v-show="show"
            @click="showImgCode"
            style="color:#0066cc; margin-top:-4px; margin-left:10px;"
          >获取验证码</b>

          <b
            class="fl"
            v-show="!show"
            style="color:#0066cc; margin-top:-4px;"
          >{{ count }} s</b>
        </p>
      </div>
    </div>
    <div class="footer">
      <span
        v-text="wrongText"
        ref="smsWrong"
      ></span>
      <button @click="submit">确认</button>
      <button @click="closeSmsCode">取消</button>
    </div>
    <sms-img
      :show="showImg"
      @sendShow="showImgModals"
      @count="runCount"
      ref="smsImg"
    ></sms-img>
  </div>
</template>
<script>
import { saveValidateType } from "@/requests/safe";
import HeaderTag from "_c/tagTitle/headerTag";
import smsImg from "./smsImg";
import { mapState } from "vuex";

export default {
  props: ['state'],
  name: "changeSms",
  components: {
    HeaderTag,
    smsImg
  },
  data() {
    return {
      showPwd: false,
      smsCode: "",
      show: true,
      count: "",
      timer: null,
      showImg: false,
      wrongText: "",
      type: ""
    };
  },
  computed: {
    ...mapState({
      saveType: state => state.user.userInfo.saveType
    })
  },
  mounted() {
  },
  methods: {
    //关闭变更短信弹框
    closeSmsCode() {
      this.showSms = false;
      this.wrongText = "";
      this.smsCode = "";
      this.$emit("showSms", false);
    },
    //验证码倒计时
    countDown() {
      // this.$emit('codeModel',false)
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    showImgModals(data) {
      this.showImg = data;
    },
    async submit() {
      let smsRe = this.$validateCenter.smsCode(this.smsCode);
      if (smsRe.res == false) {
        this.wrongText = smsRe.msg;
        this.$domFn.shake(this.$refs.smsWrong);
        return false;
      }
      if (this.saveType == 1) {
        this.type = 0;
      } else {
        this.type = 1;
      }
      let obj = {
        saveType: this.type,
        smsCode: this.smsCode
      };
      let res = await saveValidateType(obj);
      if (res.code == 200) {
        this.closeSmsCode();
        this.$router.go(0);
      } else {
        this.wrongText = res.msg;
        this.$domFn.shake(this.$refs.smsWrong);
      }
    },
    showImgCode() {
      this.showImg = true;
      this.$refs.smsImg.editCaptcha();
    },
    runCount() {
      this.countDown();
    }
  }
};
</script>
<style lang="scss" scoped>
.form-body {
  overflow: hidden;
  width: 100%;
  padding: 10px 0px 20px 0px;
  .form-top {
    width: 100%;
    padding-left: 75px;
    line-height: 50px;
    text-align: left;
  }
  .form-left {
    float: left;
    width: 150px;
    text-align: right;
    font-size: 14px;
    color: rgb(161, 161, 161);
    line-height: 40px;
  }
  .form-right {
    float: left;
    padding-left: 15px;
    width: 300px;
    text-align: left;
    line-height: 40px;
    // background-color: #0ff;
    input {
      width: 100%;
      height: 30px;
      padding-left: 10px;
      border: 1px solid #d9dee4;
    }
    span {
      position: absolute;
      transform: translate(240px, -40px);
      color: rgb(0, 102, 204);
      cursor: pointer;
    }
  }
}
.header {
  padding-left: 30px;
  text-align: left;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d9dee4;
}
.footer {
  margin-top: 20px;
  padding: 20px 0;
  margin-left: 5%;
  width: 90%;
  text-align: right;
  border-top: 1px solid #d9dee4;
  button {
    width: 100px;
    line-height: 30px;
  }
  button:nth-child(2) {
    background-color: rgb(0, 153, 204);
    border: 1px solid rgb(0, 153, 204);
    color: #fff;
  }
  button:nth-child(3) {
    margin-left: 10px;
    background-color: rgb(247, 247, 247);
    border: 1px solid #d9dee4;
  }
  span {
    float: left;
    padding-left: 50px;
    line-height: 30px;
    color: #f00;
  }
}
</style>
